
            const data = {"name":"glyph/24/chevron-right","data":{"width":"24","height":"24","viewBox":"0 0 18 18","data":"<path pid=\"0\" d=\"M13.28 8.47 7.03 2.22a.75.75 0 1 0-1.061 1.061l5.72 5.72-5.72 5.72a.75.75 0 0 0 1.06 1.061l6.25-6.25a.75.75 0 0 0 0-1.061Z\" _fill=\"#212121\" class=\"nc-icon-wrapper\"/>","originalColors":[{"type":"fill","color":"#212121"}],"stopColors":[]}}
        
                    module.exports = data
                    